import React from 'react'
import UserDashboard from '../../components/UserDashboard'

const UserDashboardPage = () => {
  return (
    <UserDashboard />
  )
}

export default UserDashboardPage